/*
 * @Author: your name
 * @Date: 2019-10-31 15:01:26
 * @LastEditTime: 2020-08-13 10:53:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/router/index.js
 */ 
import VueRouter from 'vue-router'

//导入路由列表
import routes from './routes'

//创建路由实例
const router = new VueRouter({
  routes
})

//全局路由器钩子，跳转之前
router.beforeEach((to, from, next) => {
  //修改页面标题，通过
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()//必须调用next
})

//初始化
function install(Vue) {
  //使用VueRouter插件
  Vue.use(VueRouter)
}

export default {
  install,
  router//把router实例传递出去，用于Vue实例化方法的参数
}



// WEBPACK FOOTER //
// ./src/router/index.js